// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__11n_1","header":"MessagesList_header__1m0PE","chat":"MessagesList_chat__2uViM"};